export const baseURL = "/api";
// export const baseURL = "http://175.6.184.225:7402";



// WEBPACK FOOTER //
// ./src/utils/url.js